<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Ryzyka'" [name]="'Lista'"></app-breadcrumb>
<div class="risk-configuration-list-container" fxLayout="column" fxLayoutGap="15px">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <mat-form-field style="display: none" class="risk-configuration-list-filter">
      <mat-label>UUID</mat-label>
      <input matInput placeholder="UUID" name="uuid" [(ngModel)]="initialFilters.uuid">
    </mat-form-field>

    <app-dict-insurance-companies
      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
      [multiple]="true" label="TU" class="risk-configuration-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany"
      name="in$insuranceCompany"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="true" label="Importer"
      class="risk-configuration-list-filter"
      [dictType]="'commission_importer_' + (selectedInsuranceCompanies?.length > 0 ? selectedInsuranceCompanies[0].key : '')"
      [(ngModel)]="initialFilters.in$importer" name="in$importer"
    ></app-dict>

    <app-dict
      [multiple]="true"
      label="Ryzyko" class="risk-configuration-list-filter"
      dictType="internal_risk"
      [(ngModel)]="initialFilters.in$internalRisk" name="in$internalRisk"
    ></app-dict>

    <mat-form-field class="risk-configuration-list-filter">
      <mat-label>Grupa</mat-label>
      <input matInput placeholder="Grupa" name="group" [(ngModel)]="initialFilters.group">
    </mat-form-field>

    <mat-form-field class="risk-configuration-list-filter">
      <mat-label>Ryzyko</mat-label>
      <input matInput placeholder="Ryzyko" name="risk" [(ngModel)]="initialFilters.risk">
    </mat-form-field>
  </form>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
    <ng-container *ngIf="(userPermissions | async).commission_table.read;  else noPermissions">
      <mat-form-field  appearance="standard" style="min-width: 280px;">
      <mat-label>Standardy prowizyjne</mat-label>
      <mat-select
        multiple
        [value]="selectedCommissionTableUuids"
        (selectionChange)="commissionTableSelectionChanged($event.value)
      "
      >
        <mat-select-trigger>{{ commissionTableSelectionLabel }}</mat-select-trigger>
        <mat-option
          *ngFor="let commissionTable of commissionTables"
          [value]="commissionTable.uuid"
          [disabled]="commissionTable.shortName === '2023'"
        >
          {{ commissionTable.shortName }}
        </mat-option>

      </mat-select>
    </mat-form-field>
    </ng-container>
    <ng-template #noPermissions>
      <span></span>
    </ng-template>

    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center center">
      <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <div fxLayout="column" fxFlex="100">
    <table mat-table [dataSource]="items" multiTemplateDataRows>

      <ng-container matColumnDef="logo">
        <th mat-header-cell *matHeaderCellDef> Logo </th>
        <td mat-cell *matCellDef="let element" style="width:220px" (click)="expandElement(element)">
          <img
            *ngIf="element.insuranceCompany.imageLocation"
            src="/rest/crm/insuranceCompany/{{element.insuranceCompany.id}}/image"
            alt="Logo" height="30"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompany">
        <th mat-header-cell *matHeaderCellDef> TU </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
            {{element.insuranceCompany.name}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompanyType">
        <th mat-header-cell *matHeaderCellDef> Typ TU </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.insuranceCompany.type?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="importer">
        <th mat-header-cell *matHeaderCellDef> Importer </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.importer?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="internalRisk">
        <th mat-header-cell *matHeaderCellDef> Ryzyko ASF </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.internalRisk.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            (click)="edit(element)"
            [disabled]="!(userPermissions | async).settlement.write"
            color="accent"
          ><mat-icon>edit</mat-icon></button>
          <button
            [disabled]="!(userPermissions | async).settlement.delete"
            mat-icon-button
            (click)="delete(element)"
            color="warn"
          ><mat-icon>delete</mat-icon></button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
          <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <div fxFlex="100" *ngIf="element == expandedElement">
              <div fxFlex="100" *ngIf="element == expandedElement">
                <mat-tab-group>
                  <mat-tab label="Konfiguracja">
                    <app-risk-group-view
                      [riskConfiguration]="element"
                      [commissionTables]="visibleCommissionTables"
                      (modifyClicked)="modify = true"
                      [initialFiltersRisk]="initialFilters.risk"
                      *ngIf="!modify"
                      fxFlex="100"
                    ></app-risk-group-view>

                    <app-risk-group-form
                      [riskConfiguration]="element"
                      [commissionTables]="commissionTables"
                      [visibleCommissionTableUuids]="selectedCommissionTableUuids"
                      (closeModification)="modify = false; modificationClosed()"
                      *ngIf="modify"
                      fxFlex="100"
                    ></app-risk-group-form>

                  </mat-tab>

                  <mat-tab label="Historia zmian">

                    <ng-template matTabContent>

                      <app-log-list
                        [riskConfiguration]="riskConfigurationLog"
                      ></app-log-list>

                    </ng-template>

                  </mat-tab>

                </mat-tab-group>

              </div>
            </div>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        class="table-row"
        mat-row *matRowDef="let element; let row; columns: displayedColumns;"
        [class.expanded-row]="expandedElement === element"
        [class.not-expanded-row]="expandedElement && expandedElement !== element"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-data-row"></tr>
    </table>

    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
